import React from "react";
import "../../Styles/certified/ovation.css";

export default function Finzly() {
  return (
    <>
      <div className="ovation-certified-details-section">
        <div className="ovation-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="ovation-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="ovation-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="ovation-certified-badge"
            />
            <div className="ovation-certified-company-names">
              <a href="https://4ovation.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/ovation/ovation.png"
                alt="Walkzero Logo"
                className="ovation-certified-company-logo"
              />
            </a>
              <h1 className="ovation-certified-full-name">
              Ovation Services Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="ovation-certified-details-right">
            <img
              src="/assets/ovation/ova_5.jpeg"
              alt="Finzly Office"
              className="ovation-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="ovation-certified-description">
          <h2>
            Why  Ovation Services Private Limited is an Outstanding Workplaces
          </h2>
          <p>
           Ovation Services Pvt. Ltd. is a global architectural engineering and construction company specializing in structural steel detailing, connection design, and Building Information Modeling (BIM). Headquartered in Ohio, USA, the company has an extensive presence in India with locations in Hyderabad, Chennai, and Kakinada


          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="ovation-certified-info-cards">
          <div className="ovation-certified-info-card">
            <div className="ovation-certified-info-title">COMPANY SIZE</div>
            <div className="ovation-certified-info-value">750 Employees</div>
          </div>
          <div className="ovation-certified-info-card">
            <div className="ovation-certified-info-title">INDUSTRY</div>
            <div className="ovation-certified-info-value"> Architectural Engineering & Construction (AEC) 

</div>
          </div>
          <div className="ovation-certified-info-card">
            <div className="ovation-certified-info-title">CONNECT</div>
            <div className="ovation-certified-info-icons">
              <span className="ovation-certified-icon-round">
                <a href="https://4ovation.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="ovation-certified-icon-round">
                <a href="https://www.linkedin.com/company/ovationservices/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="ovation-certified-icon-round">
                <a href="https://www.facebook.com/OvationSvcs/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="ovation-certified-info-card">
            <div className="ovation-certified-info-title">LOCATION (HQ)</div>
            <div className="ovation-certified-info-value">Hyderabad </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="ovation-certified-recognition-section">
          <h2 className="ovation-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="ovation-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="ovation-certified-recognition-image"
            />
          </div>
          <div className="ovation-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="ovation-certified-life-section">
          <h2 className="ovation-certified-life-title">
            Life at Ovation Services Private Limited
          </h2>
          <div className="ovation-certified-life-gallery">
            <div className="ovation-certified-life-col">
              <img src="/assets/ovation/ova_1.jpeg" alt="Office 1" className="ovation-certified-life-img" />
              <img src="/assets/ovation/ova_2.jpeg" alt="Team 1" className="ovation-certified-life-img" />
            </div>
            <div className="icom-certified-life-col ovation-certified-life-center">
              <img src="/assets/ovation/ova_6.jpeg" alt="Main Office" className="ovation-certified-life-img ovation-certified-life-img-large" />
            </div>
            <div className="ovation-certified-life-col">
              <img src="/assets/ovation/ova_3.jpeg" alt="Office 2" className="ovation-certified-life-img" />
              <img src="/assets/ovation/ova_4.jpeg" alt="Team 2" className="ovation-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
